import './Title.scss';

import { cva, VariantProps } from 'class-variance-authority';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { splitDataAttributes } from '../../utils/dataAttributes';

const baseClassName = 'ds-Title';

const titleVariance = cva(baseClassName, {
  variants: {
    level: {
      1: `${baseClassName}--level-1`,
      2: `${baseClassName}--level-2`,
      3: `${baseClassName}--level-3`,
      4: `${baseClassName}--level-4`,
      5: `${baseClassName}--level-5`,
    },
  },
  defaultVariants: {
    level: 1,
  },
});

type TitleProps = {
  className?: string;
  children?: ReactNode;
} & VariantProps<typeof titleVariance>;

export const Title: FC<TitleProps> = ({
  level = 1,
  className,
  children = null,
  ...rest
}) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;

  const { dataAttributes } = splitDataAttributes(rest);

  return (
    <Tag
      className={classNames(titleVariance({ level }), className)}
      {...dataAttributes}
    >
      {children}
    </Tag>
  );
};

export default Title;
